import { ActionItem, ActionsProps, asFunction } from '@common/types/actions';
import { useMemo } from 'react';

export const useResolvedActions = <T extends ActionItem>({
    actions,
    selectedItems,
}: ActionsProps<T>) => {
    return useMemo(() => {
        return actions.map((action) => {
            const getLabel = asFunction(action.label);
            const getIcon = asFunction(action.icon);
            const getColor = asFunction(action.color);

            return {
                label: getLabel(selectedItems),
                icon: getIcon(selectedItems),
                color: getColor(selectedItems),
                onClick: () => action.onClick(selectedItems),
            };
        });
    }, [actions, selectedItems]);
};
